import React from "react";
import { Button, Col, Form, Row, Select } from "antd";
import map from "lodash/map";
import get from "lodash/get";
import find from "lodash/find";

import { getButtonDisabled } from "../../utilities/helpers";

const HeaderSelector = ({
  getParts,
  filter,
  setConfig,
  setFilters,
  form,
  config,
  setParts
}) => {
  return (
    <Row className="gap-0 md:gap-4 xl:gap-0" gutter={18}>
      <Col xs={24} md={6}>
        <Form.Item
          name="Company"
          label="Company"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            placeholder="Select Company"
            optionFilterProp="label"
            showSearch
            options={map(get(config, "companies"), (company) => ({
              label: get(company, "name"),
              value: get(company, "id"),
            }))}
            rules={[{ required: true, message: "Company is required" }]}
            onChange={(val) => {
              const company = find(get(config, "companies"), ["id", val]);
              setFilters({
                ...filter,
                templateType: undefined,
                company,
              });
              setConfig({
                ...config,
                template_types: get(company, "template_access_list"),
              });
              form.setFieldsValue({
                template_type: undefined,
              });
              setParts({
                show: false,
                partsArr: [],
                displayedParts: [],
              })
            }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} lg={6}>
        <Form.Item
          name="template_type"
          label="Template Type"
          colon={false}
          layout="vertical"
        >
          <Select
            style={{ minWidth: 250 }}
            size="middle"
            rules={[
              {
                required: true,
                message: "Template type is required",
              },
            ]}
            placeholder="Type"
            options={map(get(config, "template_types"), (templateType) => ({
              label: get(templateType, "name"),
              value: get(templateType, "value"),
            }))}
            value={get(filter, "templateType")}
            onChange={(value) => {
              setFilters({
                ...filter,
                templateType: value,
              });
                setParts({
                show: false,
                partsArr: [],
                displayedParts: [],
              })
            }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item name="submit" label=" " colon={false} layout="vertical">
          <Button
            type="primary"
            className="w-30"
            onClick={() => getParts()}
            disabled={getButtonDisabled(filter, ["templateType", "company"])}
          >
            Submit
          </Button>
        </Form.Item>
      </Col>
    </Row>
  );
};
export default HeaderSelector;
